export default __webpack_public_path__ + "static/media/shoes.2ed3b37d.jpg";